export default __webpack_public_path__ + "f139981af41193a4eba3a61f4806b61e.png";